// extracted by mini-css-extract-plugin
export default {"container":"Title_container__ONVgJ","level_2":"Title_level_2__tdmtA"};